export default __webpack_public_path__ + "static/media/game-welcome-level2.cf143d2d.png";